import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { setCircularLoading } from "../../../reducers/UiReducer";
import { getService } from "../../../reducers/service";
import { notify } from "../../../reducers/NotifierReducer";
import { serviceNames } from "../../../utils/constants";
import { PATH_TRAINING_COURSES } from "../../../utils/routeConstants";
import {
  formatToTwoDecimals,
  mapDictionaryOptions,
} from "../../../utils/functions";
import { dateTimePicker } from "../../../reducers/TimeReducer";

export const useCourseData = (id, reset) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [loaded, setLoaded] = useState(false);
  const userAgency = useSelector((state) => state.user.userAgency);
  const [locationOptions, setLocationOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const dictionary = useSelector((state) => state.dictionary.dictionary);
  const tagTypeOptions = mapDictionaryOptions(dictionary.codePerTagTypes);
  useEffect(() => {
    let isMounted = true;

    const init = async () => {
      try {
        dispatch(setCircularLoading(true));
        setLoaded(false);
        const distinctService = getService(serviceNames.trainingCourseDistinct);
        const locationResponse = await distinctService.find({
          query: { column: ["location", "category"], agencyId: userAgency },
        });
        setLocationOptions(locationResponse.location);
        setCategoryOptions(locationResponse.category);

        if (id) {
          const service = getService(serviceNames.trainingCourse);

          const resultData = await service.find({
            query: {
              id: id,
              agencyId: userAgency,
            },
          });

          const result = resultData?.data?.[0] || null;

          if (!result) {
            setTimeout(() => {
              dispatch(notify("You don't have access to this course.", "warning"));
            }, 1000);
            history.go(-1);
            return;
          }

          if (isMounted && result) {
            reset({
              id: result.id || null,
              courseName: result.courseName || "",
              courseBeginDate: result.courseBeginDate
                ? dateTimePicker(result.courseBeginDate)
                : "",
              courseEndDate: result.courseEndDate
                ? dateTimePicker(result.courseEndDate)
                : "",
              location: result.location || "",
              hours: result.hours || "",
              category: result.category || "",
              approved: result.approved || false,
              courseNumber: result.courseNumber || "",
              instructor: result.instructor || "",
              certification: result.certification || "",
              expireDate: result.expireDate
                ? dateTimePicker(result.expireDate)
                : "",
              certificationEntered: result.certificationEntered || false,
              tuitionDefault:
                result.tuitionDefault === "" || result.tuitionDefault == null
                  ? null
                  : formatToTwoDecimals(result.tuitionDefault),
            });
          }
        }
      } catch (error) {
        console.error(error);
        if (isMounted) {
          dispatch(notify("Failed to fetch training course", "error"));
          history.push(PATH_TRAINING_COURSES);
        }
      } finally {
        dispatch(setCircularLoading(false));
        setLoaded(true);
      }
    };

    init();
    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, dispatch, reset, userAgency]);

  return {
    loaded,
    locationOptions,
    categoryOptions,
    tagTypeOptions,
  };
};
